import React, { useMemo, useState } from 'react'
import EnableQuestionnaire from 'components/QuestionnaireRequest/Property/components/Enable'
import OverrideGenericForm from 'components/QuestionnaireRequest/Property/components/OverrideGenericForm'
import LimitAcceptedFormTypes from 'components/QuestionnaireRequest/Property/components/LimitAcceptedFormTypes'
import { useDispatch, useSelector } from 'react-redux'
import {
  setEnabled,
  setGenericFormId,
  setLimitAcceptedFormTypes,
  setOverrideGenericForm,
  setQuestionnaireAcceptedFormTypes,
  setQuestionnaireType,
} from 'components/QuestionnaireRequest/Property/store/slice'

const PropertySettingTabGeneral = (props) => {
  const dispatch = useDispatch()
  const { building } = props
  const {
    enabled,
    questionnaireType,
    overrideGenericForm,
    genericFormId,
    limitAcceptedFormTypes,
    questionnaireAcceptedFormTypes,
    organizationQuestionnaireType,
  } = useSelector((state) => state.buildingQuestionnaireAdmin)

  return (
    <div style={{ width: 560 }}>
      <div className="dome-d-flex dome-flex-column dome-gap30">
        <div className="dome-d-flex dome-flex-column dome-gap6">
          <EnableQuestionnaire
            buildingId={building.id}
            enabled={enabled}
            updateEnabled={(enabled) => dispatch(setEnabled(enabled))}
            questionnaireType={questionnaireType}
            updateQuestionnaireType={(questionnaireType) => dispatch(setQuestionnaireType(questionnaireType))}
            organizationQuestionnaireType={organizationQuestionnaireType}
          />
          <OverrideGenericForm
            buildingId={building.id}
            overrideGenericForm={overrideGenericForm}
            updateOverrideGenericForm={(enabled) => dispatch(setOverrideGenericForm(enabled))}
            genericFormId={genericFormId}
            updateGenericFormId={(genericFormId) => dispatch(setGenericFormId(genericFormId))}
          />
          <LimitAcceptedFormTypes
            buildingId={building.id}
            isLimitAcceptedFormTypesEnabled={limitAcceptedFormTypes}
            updateLimitAcceptedFormTypes={(limit) => dispatch(setLimitAcceptedFormTypes(limit))}
            questionnaireAcceptedFormTypes={questionnaireAcceptedFormTypes}
            updateQuestionnaireAcceptedFormTypes={(formTypes) => dispatch(setQuestionnaireAcceptedFormTypes(formTypes))}
          />
        </div>
      </div>
    </div>
  )
}

export default PropertySettingTabGeneral
